
import SEOHead from '../../components/seo/SEOHead';
import JoinHeroSection from './components/JoinHeroSection';
import CooperationTypesSection from './components/CooperationTypesSection';
import AdvantagesSection from './components/AdvantagesSection';
import RequirementsSection from './components/RequirementsSection';
import EcommercePartnersSection from './components/EcommercePartnersSection';
import ContactJoinSection from './components/ContactJoinSection';

export default function Join() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "加盟合作",
    "description": "加入顺年陈合作伙伴计划，共享年份茶市场机遇。多种合作模式，专业支持，共创辉煌。",
    "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/join`,
    "mainEntity": {
      "@type": "BusinessFunction",
      "name": "加盟合作计划",
      "description": "顺年陈品牌加盟与合作机会"
    }
  };

  return (
    <div className="min-h-screen">
      <SEOHead
        title="加盟合作 - 顺年陈合作伙伴计划"
        description="加入顺年陈合作伙伴计划，共享年份茶市场机遇。多种合作模式，专业支持，共创辉煌。了解加盟条件和合作优势。"
        keywords="加盟合作,合作伙伴,品牌加盟,代理商,顺年陈加盟,茶叶加盟"
        canonical="/join"
        structuredData={structuredData}
      />
      <JoinHeroSection />
      <CooperationTypesSection />
      <AdvantagesSection />
      <RequirementsSection />
      <EcommercePartnersSection />
      <ContactJoinSection />
    </div>
  );
}
